import React from 'react'
import { useTranslate, TextInput, NumberInput, ArrayInput, minValue, SimpleFormIterator } from 'react-admin'
import SaveIcon from '@mui/icons-material/Save'
import { Dialog, DialogContent, DialogTitle, Grid, DialogActions } from '@mui/material'
import { usePaymentContext } from 'src/components/pages/payment/payment/context/paymentContext'
import LoadingButton from '@mui/lab/LoadingButton'

export const CurrencyExchangeModal = ({ open, handleClose, titleModal }) => {
  const translate = useTranslate()
  const { paymentExchanges } = usePaymentContext()
  return (
    <Dialog open={open} maxWidth='lg' fullWidth={true}>
      <DialogTitle>{titleModal}</DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          <ArrayInput
            source='currencies_exchange'
            defaultValue={paymentExchanges.filter((currency) => !currency?.is_reverse)}
          >
            <SimpleFormIterator disableAdd disableRemove disableReordering inline>
              <TextInput source='currency_relation.short_name' label={null} disabled />
              <TextInput source='currency_to_relation.short_name' label={null} disabled />
              <NumberInput source='value' label='' validate={[minValue(0.000000000000001)]} />
            </SimpleFormIterator>
          </ArrayInput>
        </Grid>

        <DialogActions className='dialog-actions' style={{ marginTop: '20px' }}>
          <LoadingButton variant='contained' startIcon={<SaveIcon />} onClick={handleClose}>
            {translate('ra.action.save')}
          </LoadingButton>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}
